import React, {Component} from 'react';
import Modal from '../Modal';
import {disableProductsClick, enableProductsClick} from '../../helpers/click';
import PurchaseLimitIndexContainer from "../../components/purchase_limits/purchase_limit_index_container";
import { KioskHeaderDiv, KioskHeaderTitleDiv } from '../../pages';
import { CloseIcon } from "../../icons";
import CartItem2 from '../CartItem2';
import { getSvgIcon, productHasSizes } from '../../helpers/productHelper';
import {
  secondaryColor
} from '../../config/const';
import './style.css';
import { LIGHT_GREY } from '../../config/colors';
import { disableBodyOverflow, enableBodyOverflow } from '../../helpers/scroll';

const styles = {
  closeIcon: { position: 'absolute', padding: '10px', right: '0', fill: '#616161', height: "35px", width: "35px" }
};
class PurchaseLimitsModal extends Component {
  state = {}
  componentWillMount() {
    window.history.pushState('forward', null, '');
    disableProductsClick();
    disableBodyOverflow();
  }
  componentDidMount () {
    this.props.getSummary();
  }
  componentWillUnmount() {
    setTimeout(() => {
      enableProductsClick();
    }, 200);
    enableBodyOverflow();
  }
  onCloseRequest = () => {
    this.props.hideModal();
  }
  handleQuantityUp = (item) => {
    if (item.quantity < item.unitsInStock) {
      this.props.increaseProductQnt(item.productId);
    }
  }
  handleQuantityDown = (item) => {
    if (item.quantity === 1) return;
    this.props.substructProductQnt(item.productId);
  }
  handleRemove = (productId) => {
    this.props.removeProduct(productId);
  }
  getCheckoutItems = () => {
    const {items, summary} = this.props;
    return (
      <div className="treez-checkout-items" style={{
          overflowY: "auto", 
          borderTop: '2px solid rgb(230, 230, 230)',
          paddingBottom: '1em'
        }}>
        {items.length === 0 && <div className="no-items">No items in your cart yet.</div>}
        {items.map((item, index) => 
          <CartItem2
            isWeight={productHasSizes(item.type)}
            color={secondaryColor}
            typeImgSrc={getSvgIcon(item.type)}
            edit
            key={index}
            index={index}
            item={item}
            ticketItems={summary.ticketItems}
            onQuantityUp={this.handleQuantityUp.bind(null, item)}
            onQuantityDown={this.handleQuantityDown.bind(null, item)}
            onRemove={this.handleRemove.bind(null, item.productId)}
            isPaymentKiosk={false}
          />
          )}
      </div>
    );
  }

  getHeaderText = () => {
    return this.props.purchaseLimitsExceeded ? 'OVER PURCHASE LIMITS' : 'PURCHASE LIMITS';
  }
  getSubText = () => {
    return "Adding the item to cart will exceed your purchase limits. Please edit the following cart items to remain within the limit."
  }
  secondaryColor = ['#', this.props.secondaryColor].join('');
  floatingLabelStyle = { color: this.secondaryColor };
  underlineFocusStyle = { borderColor: this.secondaryColor };

  render() {
    const {purchaseLimitsExceeded} = this.props;
    return (
      <Modal
        scrollable={this.props.isPhone}
        overlayTop={0}
        closeOnOverlayClick={true}
        closeOnOutsideClick={false}
        isOpened={true}
        onClose={this.onCloseRequest}>
          <CloseIcon onClick={() => this.props.hideModal()} color={LIGHT_GREY} style={styles.closeIcon} />
          <KioskHeaderDiv style={{padding:'45px 0 0'}}>
            <KioskHeaderTitleDiv style={{fontSize:'35px'}}>{this.getHeaderText()}</KioskHeaderTitleDiv>
          </KioskHeaderDiv>
          {purchaseLimitsExceeded 
            && 
            <div className="purchase-limits-warn">{this.getSubText()}</div>
          }
          <div className="purchase-limits">
            <PurchaseLimitIndexContainer/>
          </div>
       </Modal>
    );
  }
}

PurchaseLimitsModal.propTypes = {
}

export default PurchaseLimitsModal;



// WEBPACK FOOTER //
// ./src/components/PurchaseLimitsModal/PurchaseLimitsModal.jsx